import React, { PureComponent } from 'react';
import TranslatedCopy from '../../intl/translated-copy';
import {
  retriveActualHostUrl,
  setTabIndex,
} from '../../utilities/helpers';
import cx from 'classnames';
import Pictogram from '../global/pictogram';
import Popup from '../global/popup';
import PersistentLogin from '../global/persistent-login';

class MenuResponsive extends PureComponent {
  constructor() {
    super();
    this.state = {
      showResMenu: false,
    };

    this.headerLogo = null;
    this.headerNavListWrapper = null; 
    this.hamburgerMenu = null;
    this.headerCart = null;
    this.mainContainer = null;
  }

  componentWillMount() {
    // Replicando el funcionamiento para cerrar el modal responsivo de profile cuando se da un tap en cualquier elemento. 
    // ( Sin que se le pase el foco a algun icono, link, input, etc).

    this.mainContainer = document.querySelector('.manageOptionTrips');
    this.headerLogo = document.querySelector('.Header-logo');
    this.hamburgerMenu = document.querySelector('.Header-hamburger');
    this.headerCart = document.querySelector('.HeaderCart');
    this.headerNavListWrapper = document.querySelector('.Header-navListWrapper');

    window.addEventListener('click', () => {
      this.handleRemoveTapMenu();
    } );
  }

  render() {
    const {
      breakpointNewDesign,
      dispatch,
      initials,
      isActiveFlowCorporate,
      isActivePersistentLoginPopup,
      isPersistentLogin,
      openModalLogin,
    } = this.props;

    const { showResMenu } = this.state;
    const user = localStorage.getItem('initials');

    const centralPadsIcons = cx( {
      'divider-responsive': user ? true : false,
      'divider-responsive--nosession': !user ? true : false,
      'header-userIcon-responsive' : true,
    } );
    const classIsCorporateFlow = cx({
      'Header-userIcon': true,
      'is-active': showResMenu,
      'is-corporate': isActiveFlowCorporate,
    });
    const isMobile = breakpointNewDesign === 'small';
    const showPopupPersistentLogin = isPersistentLogin && !isMobile && isActivePersistentLoginPopup;
    const showMessagePersistentLogin = isPersistentLogin && isMobile;

    this.mainContainer = document.querySelector('.manageOptionTrips');
    this.headerLogo = document.querySelector('.Header-logo');
    this.hamburgerMenu = document.querySelector('.Header-hamburger');
    this.headerCart = document.querySelector('.HeaderCart');
    this.headerNavListWrapper = document.querySelector('.Header-navListWrapper');

    if ( this.state.showResMenu && ( this.mainContainer && !this.mainContainer.className.includes('blockBody-actions') ) &&
    ( this.headerLogo && !this.headerLogo.className.includes('blockBody-actions') ) && 
    ( this.hamburgerMenu && !this.hamburgerMenu.className.includes('blockBody-actions') ) &&
    ( this.headerCart && !this.headerCart.className.includes('blockBody-actions') ) &&
    ( this.headerNavListWrapper && !this.headerNavListWrapper.className.includes('blockBody-actions') ) ) {
      this.mainContainer.classList.toggle('blockBody-actions--content'); // Contenido (o mejor dicho el contenedor principal)
      this.headerLogo.classList.toggle('blockBody-actions'); // Logo
      this.headerCart.classList.toggle('blockBody-actions'); // carrito de compras.
      this.hamburgerMenu.classList.toggle('blockBody-actions'); // menu de hamburguesa
      this.headerNavListWrapper.classList.toggle('blockBody-actions'); // Cuando estamos en resolucion de tablet aparece la barrita del header con opciones de menu.
    } else if ( !this.state.showResMenu && ( this.mainContainer && this.mainContainer.className.includes('blockBody-actions') ) &&
    ( this.headerLogo && this.headerLogo.className.includes('blockBody-actions') ) &&
    ( this.hamburgerMenu && this.hamburgerMenu.className.includes('blockBody-actions') ) &&
    ( this.headerCart && this.headerCart.className.includes('blockBody-actions') ) && 
    ( this.headerNavListWrapper && this.headerNavListWrapper.className.includes('blockBody-actions') ) ) {
      this.mainContainer.classList.remove('blockBody-actions--content');
      this.headerLogo.classList.remove('blockBody-actions');
      this.headerCart.classList.remove('blockBody-actions'); // carrito de compras.
      this.hamburgerMenu.classList.remove('blockBody-actions');
      this.headerNavListWrapper.classList.remove('blockBody-actions'); // Cuando estamos en resolucion de tablet aparece la barrita del header con opciones de menu.
    }

    const condensedLogoID = 'logoCondensedAMV2Blue';
    const logoID = condensedLogoID;

    return (
      <div className={ centralPadsIcons }>
        {
          initials ?
            <div>
              <button className= { classIsCorporateFlow }
                onClick={ (e) => this.handleShowMenu(e) }>
                { initials }
              </button>
              { showPopupPersistentLogin &&
                  <Popup
                    className='PersistentLogin-popup'
                    position='right' >
                    <PersistentLogin
                      dispatch={ dispatch }
                      openModalLogin={ openModalLogin } />
                  </Popup>
              }
              {
                this.state.showResMenu &&
                  <div className='menu-responsive'>
                    <ul>
                      <div className='HeaderProfileMenu-section--item HeaderProfileMenu-section--title'>
                        <TranslatedCopy copyID='LGN_MENU_TITLE' tagName='span' />
                      </div>
                      { showMessagePersistentLogin &&
                          <PersistentLogin
                            onlyMessage={ true }
                            openModalLogin={ openModalLogin } />
                      }
                      <li className='HeaderProfileMenu-section--item'>
                        <i className='Icon Icon--profileNew'></i>
                        <a className='HeaderProfileMenu-link'
                          onClick={ ( e ) => this.redirectProfileEFour( e, 1 ) }>
                          <TranslatedCopy copyID='USER_PROFILE_MY_AEROMEXICO' />
                        </a>
                      </li>
                      <li className='HeaderProfileMenu-section--item'>
                        <i className='Icon Icon--mytripsNew'></i>
                        <a className='HeaderProfileMenu-link'
                          onClick={ ( e ) => this.redirectProfileEFour( e, 0 ) }>
                          <TranslatedCopy copyID='NS_MYB_HEADER' />
                        </a>
                      </li>
                      <li className='HeaderProfileMenu-section--item'>
                        <i className='Icon Icon--walletBitcoin'></i>
                        <a className='HeaderProfileMenu-link'
                          onClick={ ( e ) => this.redirectProfileEFour( e, 2 ) }>
                          <TranslatedCopy copyID='USER_PROFILE_MY_PAYMENTS' />
                        </a>
                      </li>
                      <li className='HeaderProfileMenu-section--item HeaderProfileMenu-section--cp'>
                        <Pictogram  id={ logoID } />
                        <a className='HeaderProfileMenu-link'
                          onClick={ ( e ) => this.redirectProfileEFour( e, 3 ) }>
                          <TranslatedCopy copyID='USER_PROFILE_MY_CLUB_PREMIER' />
                        </a>
                      </li>
                    </ul>
                    <div className='menu-responsive--logout' onClick={this.props.onSignOut}>
                      <span className='Icon Icon--log-out icon-profile-responsive'/>
                      <span>
                        <TranslatedCopy copyID='APP_LOGOUT'/>
                      </span>
                    </div>
                  </div>
              }
            </div>
            :
            <button className='menu-responsive--userlogin' onClick={this.props.openModalLogin}>
              <span className='Icon Icon--user_login icon-profile-responsive' />
            </button>
        }
      </div>
    );
  }

  handleRemoveTapMenu = () => {
    const { showResMenu } = this.state;

    if ( showResMenu ) {
      this.setState( { 
        showResMenu : false,
      } );
    } else 
      return;
  }

  redirectProfileEFour = ( e, tabIndex ) => { // Delegate the user validation onClick.
    const {
      isSignIn,
      language,
      openModalLogin,
      storefront,
    } = this.props;

    setTabIndex(tabIndex);

    if (!isSignIn) {
      openModalLogin();
    } else {
      const redirectHost = window.location.host;

      e.preventDefault();
      retriveActualHostUrl(redirectHost, language, storefront);
    }
  }

  handleShowMenu( e ) {
    e.stopPropagation();
    const { showResMenu } = this.state;

    this.setState({
      showResMenu: !showResMenu,
    });
  }
}

export default MenuResponsive;
